/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 room.glb --transform
Author: Anex (https://sketchfab.com/anex)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/room-6417cbc1870a4a1691cca06912ae0369
Title: Room
*/

import { useGLTF } from '@react-three/drei';
import { Material, Mesh } from 'three';

type GLTFResult = {
  nodes: {
    Object_2: Mesh;
    Object_4: Mesh;
    Object_7: Mesh;
    Object_10: Mesh;
    Object_11: Mesh;
    Object_12: Mesh;
    Object_13: Mesh;
    Object_14: Mesh;
    Object_15: Mesh;
    Object_17: Mesh;
    Object_18: Mesh;
  };
  materials: {
    Material: Material;
    'Material.002': Material;
    'Material.003': Material;
    krzeslo_okno: Material;
    podloga: Material;
    sciana_okno: Material;
    'stolik.001': Material;
    'Material.005': Material;
    mata: Material;
    stolik: Material;
  };
};

export type RoomProps = {
  [key: string]: unknown;
};

export function Room(props: RoomProps) {
  const { nodes, materials } = useGLTF('./3D/room.glb') as unknown as GLTFResult;

  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} position-z={0.62}>
        <mesh castShadow receiveShadow geometry={nodes.Object_2.geometry} material={materials.Material} />
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_3.geometry} material={materials['Material.002']} />*/}
        <mesh castShadow receiveShadow geometry={nodes.Object_4.geometry} material={materials['Material.003']} />
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_6.geometry} material={materials.krzeslo_1} />*/}
        <mesh castShadow receiveShadow geometry={nodes.Object_7.geometry} material={materials.krzeslo_okno} />
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_8.geometry} material={materials.krzeslo_prawe} />*/}
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_9.geometry} material={materials.krzeslo_srodek} />*/}
        <mesh castShadow receiveShadow geometry={nodes.Object_10.geometry} material={materials.podloga} />
        <mesh castShadow receiveShadow geometry={nodes.Object_11.geometry} material={materials.sciana_okno} />
        <mesh castShadow receiveShadow geometry={nodes.Object_12.geometry} material={materials['stolik.001']} />
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_16.geometry} material={materials['Material.006']} />*/}
        {/*<mesh castShadow receiveShadow geometry={nodes.Object_5.geometry} material={materials['Material.004']} />*/}
        <mesh geometry={nodes.Object_13.geometry}>
          <meshStandardMaterial transparent opacity={0.5} />
        </mesh>
        <mesh castShadow receiveShadow geometry={nodes.Object_14.geometry} material={materials['Material.002']} />
        <mesh castShadow receiveShadow geometry={nodes.Object_15.geometry} material={materials['Material.005']} />
        <mesh castShadow receiveShadow geometry={nodes.Object_17.geometry} material={materials.mata} />
        <mesh castShadow receiveShadow geometry={nodes.Object_18.geometry} material={materials.stolik} />
      </group>
    </group>
  );
}

useGLTF.preload('./3D/room.glb');
